import * as React from "react";
const SvgIcSeparator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 11, width: 22, height: 2, fill: "currentColor" }));
export default SvgIcSeparator;
